import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import {CarouselComponent, CarouselService} from "@spartacus/storefront";
import {tap} from "rxjs/operators";
import {EbCarouselService} from "./eb-carousel.service";

@Component({
    selector: 'eb-carousel',
    templateUrl: './eb-carousel.component.html',
    styleUrls: ['./eb-carousel.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class EbCarouselComponent extends CarouselComponent implements OnInit, AfterViewInit{
  @ViewChild('Element') element: ElementRef;

  @Input() itemHeight = '90px'
  constructor(
      protected el: ElementRef,
      protected service: CarouselService,
      protected ebCarouselService: EbCarouselService
  ){
    super(el, service)
  }

  ngAfterViewInit() {
      this.size$ = this.ebCarouselService
          .getItemsPerSlideByHeight(this.element.nativeElement, this.itemHeight)
          .pipe(tap(() => (this.activeSlide = 0)));
  }
}
